import type React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Download from '@/assets/icons/download.svg?component';
import { SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';
import { Menu, MenuContent, MenuTrigger } from '@/components/molecules/Menu';

import styles from './ExportDataDropDown.module.scss';

export interface ExportDataDropDownProps {
    disabled?: boolean;
    children?: React.ReactNode;
}

/**
 * "Export" and a panel of download buttons (CSV, XLSX, PDF...) supplied as children. A panel
 * rather than a menu: the children are buttons with their own loading states.
 */
function ExportDataDropDown({ children, disabled = false }: ExportDataDropDownProps) {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const label = t('common.actions.export');

    return (
        <div className={styles.exportDataDropDown}>
            <Menu kind="panel" isOpen={isOpen} onOpenChange={setIsOpen} disabled={disabled}>
                <MenuTrigger
                    variant="secondary"
                    disabled={disabled}
                    trackingId="export_data_open"
                    aria-haspopup={false}
                    icon={<SvgIcon icon={Download} size="custom" customSize={20} />}
                    caret>
                    {label}
                </MenuTrigger>
                {/* A group, as DropDownPanel: the buttons are not menu items, and announced as a
                    menu the panel had no items. */}
                <MenuContent align="end" role="group" aria-label={label} className={styles.panel}>
                    {isOpen ? children : null}
                </MenuContent>
            </Menu>
        </div>
    );
}

export default ExportDataDropDown;
export { ExportDataDropDown };
